// extracted by mini-css-extract-plugin
export var checkbox = "_2e-0";
export var circle = "_2e-3";
export var horizontalContainer = "_2e-7";
export var sm = "_2e-5";
export var switch0 = "_2e-2";
export var switchDisabled = "_2e-8";
export var switchEnabled = "_2e-1";
export var textSwitchContainer = "_2e-9";
export var textSwitchOption = "_2e-a";
export var textSwitchOptionSelected = "_2e-b";
export var verticalContainer = "_2e-6";
export var xs = "_2e-4";